import { Flex, Box, Text, SimpleGrid } from "@chakra-ui/layout";
import { MdHowToVote } from "react-icons/md";
import { FaDoorOpen, FaCalendarCheck, FaCommentDots } from "react-icons/fa";

import { AiOutlineFileText } from "react-icons/ai";
import { BsBoxSeam } from "react-icons/bs";
import history from "infra/helpers/history";
import colors from "core/resources/theme/colors";
import Card1Vertical from "components/Cards/Card1Vertical";
import Can from "components/Can";
import { PermissaoEnum } from "core/resources/enums/permissao";
import { checkOrPermission } from "infra/helpers/permission";

function AcoesRapidas() {
  const isEmpty = !checkOrPermission([
    PermissaoEnum.Backoffice.Administrativo.Portaria.Gerenciar,
    PermissaoEnum.Backoffice.Administrativo.Reserva.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.Mensagem.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.Documento.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.Votacao.Visualizar,
  ]);

  if (isEmpty) {
    return null;
  }

  return (
    <Box>
      <Flex mb="8px">
        <Text fontSize="20px">Ações rápidas</Text>
      </Flex>
      <SimpleGrid columns={{ sm: 2, md: 3, lg: 3 }} gap="16px">
        <Can
          permission={
            PermissaoEnum.Backoffice.Administrativo.Portaria.Gerenciar
          }
        >
          <Card1Vertical
            bg={colors.pink500}
            name="Portaria"
            icon={<FaDoorOpen fontSize="24px" color={colors.pink100} />}
            complete={false}
            onClick={() => {
              history.push("/administracao/portaria");
            }}
            py={3}
          />
        </Can>
        <Can
          permission={
            PermissaoEnum.Backoffice.Administrativo.Reserva.Visualizar
          }
        >
          <Card1Vertical
            bg={colors.blue100}
            name="Reservas"
            icon={<FaCalendarCheck fontSize="24px" color={colors.blue500} />}
            complete={false}
            onClick={() => {
              history.push("/administracao/reservas");
            }}
            py={3}
          />
        </Can>
        <Can
          permission={
            PermissaoEnum.Backoffice.Administrativo.Mensagem.Visualizar
          }
        >
          <Card1Vertical
            bg={colors.green100}
            name="Mensagens"
            icon={<FaCommentDots fontSize="24px" color={colors.green} />}
            complete={false}
            onClick={() => {
              history.push("/administracao/mensagens");
            }}
            py={3}
          />
        </Can>

        <Can
          permission={
            PermissaoEnum.Backoffice.Administrativo.Documento.Visualizar
          }
        >
          <Card1Vertical
            bg={colors.orange50}
            name="Documentos"
            icon={<AiOutlineFileText fontSize="24px" color={colors.orange} />}
            complete={false}
            onClick={() => {
              history.push("/cadastros/documentos");
            }}
            py={3}
          />
        </Can>
        <Can
          permission={
            PermissaoEnum.Backoffice.Administrativo.Votacao.Visualizar
          }
        >
          <Card1Vertical
            bg={colors.purple50}
            name="Votação"
            icon={<MdHowToVote fontSize="24px" color={colors.purple200} />}
            complete={false}
            onClick={() => {
              history.push("/administracao/assembleias");
            }}
            py={3}
          />
        </Can>
        <Can
          permission={
            PermissaoEnum.Backoffice.Administrativo.Encomenda.Visualizar
          }
        >
          <Card1Vertical
            bg={colors.yellow50}
            name="Encomendas"
            icon={<BsBoxSeam fontSize="24px" color={colors.yellow500} />}
            complete={false}
            onClick={() => {
              history.push("/administracao/encomenda");
            }}
            py={3}
          />
        </Can>
      </SimpleGrid>
    </Box>
  );
}

export default AcoesRapidas;
